var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"setting-radio-icon",attrs:{"id":_vm.id}},_vm._l((_vm.options),function(option,index){return _c('li',{key:index},[_c('input',{attrs:{"id":_vm._uid + '__' + index,"name":_vm.name + '_radio-icon',"type":"radio"},domProps:{"value":option,"checked":_vm.modelValue === option},on:{"change":function($event){_vm.updateIcon(option)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm._uid + '__' + index}},[_c('i',{class:option})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71957093","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/fields/radio-icon.vue
// module id = 74
// module chunks = 0